import styled from "styled-components";

import colors from "@src/common/styles/colors";
import { defaultLetterSpacing, media } from "@src/common/styles/mixins";
import { TestStatus } from "@src/modules/shared/types";
import { DEFAULT_MARGIN_XS } from "@src/common/styles/const";

type StatusProps = { status: TestStatus };

export const StatusWrapper = styled.div<StatusProps>`
  display: flex;
  align-items: center;
  border-top-left-radius: 6px;
  border-bottom-right-radius: 6px;
  margin-right: auto;
  padding: ${DEFAULT_MARGIN_XS}px;
  opacity: 0.8;
  background-color: ${(p) =>
    p.status === TestStatus.Ready
      ? colors.green
      : p.status === TestStatus.InProgress
      ? colors.darkBlue
      : p.status === TestStatus.ActionNeeded
      ? colors.yellow
      : colors.red};

  ${media.down("MOBILE")`
    padding: ${DEFAULT_MARGIN_XS}px 3px;
    svg {
      height: 12px;
    }  
  `}
`;

export const StatusDescription = styled.p<StatusProps>`
  ${defaultLetterSpacing};
  font-size: 10px;
  font-weight: 600;
  color: ${(p) =>
    p.status === TestStatus.ActionNeeded ? colors.almostBlack : colors.white};
  margin: 0 ${DEFAULT_MARGIN_XS}px;
  padding-bottom: 2px;

  ${media.down("MOBILE")`
    font-size: 8px;
    padding-bottom: 1px;
  `}
`;
